@if (isInitialized && controllerLines.length > 0) {
  <oe-flat-widget [title]="'EDGE.INDEX.WIDGETS.CHANNELTRESHOLD.TITLE' | translate" button [link]="'/device/' + edge.id + newNavigationUrlSegment + '/history/channelsinglethresholdchart'" [icon]="{ name: 'radio-button-on-outline', color: 'normal', size: 'large' }">
    @for (controllerLine of controllerLines; track controllerLine.channelAddress) {
      <oe-flat-widget-line [name]="controllerLine.name" [channelAddress]="controllerLine.channelAddress" [converter]="FORMAT_SECONDS_TO_DURATION"></oe-flat-widget-line>
    }
  </oe-flat-widget>
}
